import React from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

export type DeleteCategoryRequest = {
    id: number
    label: string
    descendantCount: number
}

type Props = {
    request: DeleteCategoryRequest | null
    onConfirm: () => void
    onCancel: () => void
}
/** Confirms removing a category; warns when its sub-categories go with it */
export const DeleteCategoryDialog: React.FC<Props> = ({request, onConfirm, onCancel}) => {
    const n = request?.descendantCount ?? 0;
    return <Dialog open={request !== null} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Delete category</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Do you want to delete <Box component="strong" sx={{color: 'text.primary'}}>{request?.label}</Box>?
            </DialogContentText>
            {n > 0 && <DialogContentText sx={{mt: 1.5, color: 'error.main'}}>
                All {n} {n === 1 ? 'sub-category' : 'sub-categories'} under it will also be removed.
            </DialogContentText>}
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <Button variant="contained" color="error" onClick={onConfirm} autoFocus>Delete</Button>
        </DialogActions>
    </Dialog>
}
